export function scrollFading() {
  const els = document.querySelectorAll('.js-scroll-fading');
  if(els.length) {
    els.forEach((el) => {
      const fadeStart = 0; // 透明度が変化し始めるスクロール位置
      const fadeEnd = 70; // 透明度が0になるスクロール位置
      const updateOpacity = () => {
        const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const opacity = 1 - Math.min(1, (scTop - fadeStart) / (fadeEnd - fadeStart));
        if (scTop < fadeEnd) {
          el.style.opacity = opacity;
        } else {
          el.style.opacity = 0;
        }
      }
      // スクロールイベントに関数をバインド
      document.addEventListener('scroll', updateOpacity);

      // 初期状態の設定
      updateOpacity();
    })
  }
}